export const LISTING_ATTENTION_ACTION_KEY = {
  approveApplicant: 'approve_applicant',
  assignManager: 'assign_manager',
  completeReadiness: 'complete_readiness',
  decideApplicant: 'decide_applicant',
  fixDescription: 'fix_description',
  fixPhoto: 'fix_photo',
  fixReadiness: 'fix_readiness',
  fixRent: 'fix_rent',
  open: 'open',
  publish: 'publish',
  publishPortals: 'publish_portals',
  retryPortal: 'retry_portal',
  reviewApplicants: 'review_applicants',
  transferChanges: 'transfer_changes',
}

export const LISTING_ATTENTION_DESTINATION = {
  applicants: 'applicants',
  descriptionEdit: 'descriptionEdit',
  keyFactsEdit: 'keyFactsEdit',
  managerEdit: 'managerEdit',
  photoEditor: 'photoEditor',
  publishing: 'publishing',
  readiness: 'readiness',
}

export const LISTING_ATTENTION_READINESS_DESTINATION = {
  description: LISTING_ATTENTION_DESTINATION.descriptionEdit,
  photo: LISTING_ATTENTION_DESTINATION.photoEditor,
  rent: LISTING_ATTENTION_DESTINATION.keyFactsEdit,
}

export const LISTING_ATTENTION_ACTION_DESTINATION = {
  [LISTING_ATTENTION_ACTION_KEY.approveApplicant]:
    LISTING_ATTENTION_DESTINATION.applicants,
  [LISTING_ATTENTION_ACTION_KEY.assignManager]:
    LISTING_ATTENTION_DESTINATION.managerEdit,
  [LISTING_ATTENTION_ACTION_KEY.completeReadiness]:
    LISTING_ATTENTION_DESTINATION.readiness,
  [LISTING_ATTENTION_ACTION_KEY.decideApplicant]:
    LISTING_ATTENTION_DESTINATION.applicants,
  [LISTING_ATTENTION_ACTION_KEY.fixDescription]:
    LISTING_ATTENTION_DESTINATION.descriptionEdit,
  [LISTING_ATTENTION_ACTION_KEY.fixPhoto]:
    LISTING_ATTENTION_DESTINATION.photoEditor,
  [LISTING_ATTENTION_ACTION_KEY.fixReadiness]:
    LISTING_ATTENTION_DESTINATION.readiness,
  [LISTING_ATTENTION_ACTION_KEY.fixRent]:
    LISTING_ATTENTION_DESTINATION.keyFactsEdit,
  [LISTING_ATTENTION_ACTION_KEY.open]:
    LISTING_ATTENTION_DESTINATION.photoEditor,
  [LISTING_ATTENTION_ACTION_KEY.publish]:
    LISTING_ATTENTION_DESTINATION.publishing,
  [LISTING_ATTENTION_ACTION_KEY.publishPortals]:
    LISTING_ATTENTION_DESTINATION.publishing,
  [LISTING_ATTENTION_ACTION_KEY.retryPortal]:
    LISTING_ATTENTION_DESTINATION.publishing,
  [LISTING_ATTENTION_ACTION_KEY.reviewApplicants]:
    LISTING_ATTENTION_DESTINATION.applicants,
  [LISTING_ATTENTION_ACTION_KEY.transferChanges]:
    LISTING_ATTENTION_DESTINATION.publishing,
}
